
import React from "react";
import { TrackingField } from "./TrackingField";
import { TrackingToggle } from "./TrackingToggle";

interface SnapchatAdsSectionProps {
  snapchatPixelId: string;
  setSnapchatPixelId: (value: string) => void;
  snapchatApiToken: string;
  setSnapchatApiToken: (value: string) => void;
  isEditing: boolean;
  isPixelEnabled?: boolean;
  setIsPixelEnabled?: (value: boolean) => void;
  isApiEnabled?: boolean;
  setIsApiEnabled?: (value: boolean) => void;
}

export const SnapchatAdsSection: React.FC<SnapchatAdsSectionProps> = ({
  snapchatPixelId,
  setSnapchatPixelId,
  snapchatApiToken,
  setSnapchatApiToken,
  isEditing,
  isPixelEnabled = true,
  setIsPixelEnabled = () => {},
  isApiEnabled = true,
  setIsApiEnabled = () => {},
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">Snapchat Ads</h3>
        
        {isEditing && (
          <div className="flex items-center space-x-4">
            <TrackingToggle
              id="snapchat-pixel-enabled"
              label="Activer le pixel"
              checked={isPixelEnabled}
              onChange={setIsPixelEnabled}
            />
            <TrackingToggle
              id="snapchat-api-enabled"
              label="Activer l'API"
              checked={isApiEnabled}
              onChange={setIsApiEnabled}
              disabled={!isPixelEnabled}
            />
          </div>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TrackingField
          id="snapchat-pixel-id"
          label="Pixel ID"
          value={snapchatPixelId}
          onChange={setSnapchatPixelId}
          isEditing={isEditing}
          placeholder="Votre Pixel ID Snapchat"
          disabled={!isPixelEnabled && isEditing}
        />
        <TrackingField
          id="snapchat-api-token"
          label="API Token"
          value={snapchatApiToken}
          onChange={setSnapchatApiToken}
          isEditing={isEditing}
          isPassword={true}
          placeholder="Votre token API Snapchat"
          disabled={(!isPixelEnabled || !isApiEnabled) && isEditing}
        />
      </div>
    </div>
  );
};
